import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './SiteFooter.module.css';

const LINKS = [
  { to: '/how-it-works', key: 'nav.howItWorks' },
  { to: '/tools', key: 'nav.tools' },
  { to: '/privacy', key: 'legal.nav.privacy' },
  { to: '/terms', key: 'legal.nav.terms' },
  { to: '/security', key: 'legal.nav.security' },
  { to: '/abuse', key: 'legal.nav.abuse' },
] as const;

export default function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <nav aria-label={t('nav.legalLabel')} className={styles.links}>
          {LINKS.map((link) => (
            <Link key={link.to} to={link.to}>
              {t(link.key)}
            </Link>
          ))}
        </nav>
        <p className={styles.copyright}>{t('legal.copyright', { year: new Date().getFullYear() })}</p>
      </div>
    </footer>
  );
}
